import React, { useEffect, useRef, useState } from "react";
// import GoogleDriveUpload from "../../FileUploadToS3/GoogleDriveUpload";
import CustomModal from "../../CustomModal/CustomModal";
import { useAuth } from "../../../features/auth/AuthContext";
import { toast } from "react-toastify";
import api from "../../../api/api";
// import { CrossIcon } from '../Icons';
// import { fileIcons } from '../Icons';
// import { ReactSVG } from 'react-svg';
import SelectedFileCard from "./SelectedFileCard";
import { useAWSS3FileUpload } from "../../AWSFileUpload/AWSFilesUpload";
import { useQueryClient } from "@tanstack/react-query";
import GoogleDriveUpload from "../GoogleDriveUpload/GoogleDriveUpload";
import Loader from "./Loader";
import { Drawer } from "@mui/material";
import UploadLinkModal from "./Uploadlinkmodal";
import { useSelector } from "react-redux";

const UploadFile = ({
  showUploadPop,
  setShowUploadPop,
  currentFolder = {},
  setFileUploading = null,
  setFiles = null,
  type,
  currentLessonFolder,
  id,
  onUploadComplete = null,
  path,
  data
}) => {
  const popupRef = useRef(null);
  const fileInputRef = useRef(null);
  const [showUploadFileModal, setShowUploadFileModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { token } = useAuth();
  const queryClient = useQueryClient();

  const globalState = useSelector((state) => state.globalState);

  // with the other useState hooks
  const [showLinkModal, setShowLinkModal] = useState(false);


  const MAX_FILES = 8;
  const MAX_TOTAL_SIZE = 500 * 1024 * 1024;

  useEffect(() => {
    if (!showUploadPop) return;
    function handleClickOutside(event) {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowUploadPop(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showUploadPop]);

  const openLinkModal = () => {
    setShowUploadPop(false);   // close the small popup
    setShowLinkModal(true);
  };


  const openUploadModal = () => {
    setShowUploadPop(false);
    setShowUploadFileModal(true);
  };

  const handleGoogleDriveFiles = (files) => {
    // setShowUploadFileModal(true);
    handleFiles(files);
  };

  const handleFiles = (newFiles) => {
    // Merge with already selected files
    const combinedFiles = [...selectedFiles, ...newFiles];
    // 1️⃣ Remove duplicates
    const uniqueFiles = combinedFiles.filter(
      (file, index, self) =>
        index ===
        self.findIndex(
          (f) =>
            f.name === file.name &&
            f.size === file.size &&
            f.lastModified === file.lastModified,
        ),
    );

    // 2️⃣ Max file count
    if (uniqueFiles.length > MAX_FILES) {
      toast.error("Maximum 8 files are allowed.");
      return;
    }

    // 3️⃣ Total size check
    const totalSize = uniqueFiles.reduce((acc, file) => acc + file.size, 0);

    if (totalSize > MAX_TOTAL_SIZE) {
      toast.error("Total file size cannot exceed 500MB.");
      return;
    }

    // ✅ All validations passed
    setSelectedFiles(uniqueFiles);
    setFiles?.(uniqueFiles);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    handleFiles(e.dataTransfer.files);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleChange = (e) => {
    handleFiles(e.target.files);
  };

  const handleFileSubmit = async () => {
    const formData = new FormData();
    selectedFiles.forEach((file) => {
      formData.append("files", file);
      // backend should expect "files"
    });
    formData.append("type", "file");
    if (currentFolder?.id && ![1, 2].includes(+currentFolder.id)) {
      formData.append("parent_id", currentFolder.id);
    }
    setIsLoading(true);
    setFileUploading?.(true);
    await api
      .post("/upload/", formData, {
        headers: {
          // "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setIsLoading(false);
          toast.success("Upload Successfull.", {
            position: "top-center",
          });
          queryClient.invalidateQueries({ queryKey: ["folderContents"] });
          onUploadComplete?.();
          handleClose();
          setFileUploading?.(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        toast.error("Something went wrong. Please try again later.", {
          position: "top-center",
        });
        setFileUploading?.(false);
      });
  };

  const handleClose = () => {
    setShowUploadFileModal(false);
    setSelectedFiles([]);
    setFiles?.([]);
  };

  const removeFile = (indexToRemove) => {
    const updatedFiles = selectedFiles.filter(
      (_, index) => index !== indexToRemove,
    );
    setSelectedFiles(updatedFiles);
    setFiles?.(updatedFiles);
  };

  return (
    <>
      {showUploadPop && window.innerWidth >= 640 ? (
        <div className="absolute top-[50px] right-[5px] z-[100]">
          <div
            ref={popupRef}
            className="p-[18px] shadow-[0px_4px_25px_0px_#0000000D] rounded-[5px] bg-white flex flex-col gap-[14px] w-[15rem] border border-[#ECECEB]"
          >
            <GoogleDriveUpload
              setShowUploadPop={setShowUploadPop}
              onFilesDownloaded={handleGoogleDriveFiles}
              setIsLoading={setIsLoading}
              setShowUploadFileModal={setShowUploadFileModal}
            />
            <button
              className="border-none bg-transparent flex items-center gap-[11px]"
              onClick={openUploadModal}
            >
              <svg
                width="13"
                height="16"
                viewBox="0 0 13 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.625 13.2371H6.875V9.54167L8.41667 11.0833L9.29479 10.1923L6.25 7.1475L3.20521 10.1923L4.09625 11.0704L5.625 9.54167V13.2371ZM1.50646 15.8333C1.08549 15.8333 0.729167 15.6875 0.4375 15.3958C0.145833 15.1042 0 14.7478 0 14.3269V1.50646C0 1.08549 0.145833 0.729167 0.4375 0.4375C0.729167 0.145833 1.08549 0 1.50646 0H8.125L12.5 4.375V14.3269C12.5 14.7478 12.3542 15.1042 12.0625 15.3958C11.7708 15.6875 11.4145 15.8333 10.9935 15.8333H1.50646ZM7.5 5V1.25H1.50646C1.44229 1.25 1.38354 1.27674 1.33021 1.33021C1.27674 1.38354 1.25 1.44229 1.25 1.50646V14.3269C1.25 14.391 1.27674 14.4498 1.33021 14.5031C1.38354 14.5566 1.44229 14.5833 1.50646 14.5833H10.9935C11.0577 14.5833 11.1165 14.5566 11.1698 14.5031C11.2233 14.4498 11.25 14.391 11.25 14.3269V5H7.5Z"
                  fill="#333333"
                />
              </svg>
              <span className="text-black text-[13px] font-normal">
                Upload File
              </span>
            </button>
            {
              globalState.enabled_modules?.includes('youtube_modul') && !data?.current_folder?.course_id && (
                <button
                  className="border-none bg-transparent flex items-center gap-[11px]"
                  onClick={openLinkModal}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#333333" strokeWidth="1.8">
                    <circle cx="12" cy="12" r="9" />
                    <path d="M3 12h18M12 3c2.5 2.7 2.5 15.3 0 18M12 3c-2.5 2.7-2.5 15.3 0 18" />
                  </svg>
                  <span className="text-black text-[13px] font-normal">Upload Link</span>
                </button>
              )
            }

          </div>
        </div>
      ) : (
        <Drawer
          anchor={"bottom"}
          open={showUploadPop}
          ModalProps={{
            sx: {
              zIndex: 2000,
            },
          }}
          PaperProps={{
            sx: {
              borderTopLeftRadius: "16px",
              borderTopRightRadius: "16px",
              // optional polish 👇
              overflow: "hidden",
            },
          }}
          onClose={() => setShowUploadPop(false)}
        >
          <div
            ref={popupRef}
            className="p-[18px] bg-white flex items-start justify-center gap-8 w-full border border-[#ECECEB]"
          >
            <GoogleDriveUpload
              setShowUploadPop={setShowUploadPop}
              onFilesDownloaded={handleGoogleDriveFiles}
              setIsLoading={setIsLoading}
              setShowUploadFileModal={setShowUploadFileModal}
              mobileUpload={true}
            />
            <button
              className="border-none bg-transparent flex flex-col items-center gap-[11px]"
              onClick={openUploadModal}
            >
              <span className="border rounded-[50%] flex justify-center items-center w-[4rem] h-[4rem]">
                <svg
                  width="23"
                  height="26"
                  viewBox="0 0 13 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.625 13.2371H6.875V9.54167L8.41667 11.0833L9.29479 10.1923L6.25 7.1475L3.20521 10.1923L4.09625 11.0704L5.625 9.54167V13.2371ZM1.50646 15.8333C1.08549 15.8333 0.729167 15.6875 0.4375 15.3958C0.145833 15.1042 0 14.7478 0 14.3269V1.50646C0 1.08549 0.145833 0.729167 0.4375 0.4375C0.729167 0.145833 1.08549 0 1.50646 0H8.125L12.5 4.375V14.3269C12.5 14.7478 12.3542 15.1042 12.0625 15.3958C11.7708 15.6875 11.4145 15.8333 10.9935 15.8333H1.50646ZM7.5 5V1.25H1.50646C1.44229 1.25 1.38354 1.27674 1.33021 1.33021C1.27674 1.38354 1.25 1.44229 1.25 1.50646V14.3269C1.25 14.391 1.27674 14.4498 1.33021 14.5031C1.38354 14.5566 1.44229 14.5833 1.50646 14.5833H10.9935C11.0577 14.5833 11.1165 14.5566 11.1698 14.5031C11.2233 14.4498 11.25 14.391 11.25 14.3269V5H7.5Z"
                    fill="#333333"
                  />
                </svg>{" "}
              </span>
              <span className="text-['#232323'] text-[0.9rem] font-normal">
                Upload File
              </span>
            </button>
          </div>
        </Drawer>
      )}

      <CustomModal
        primaryDisbaled={selectedFiles.length === 0 || isLoading}
        onClose={handleClose}
        secondaryClick={handleClose}
        primaryClick={handleFileSubmit}
        primaryLabel={!isLoading ? "Upload" : null}
        secondaryLabel={!isLoading ? "Cancel" : null}
        open={showUploadFileModal}
        title="Upload Files"
      >
        <div className="flex flex-col align-center gap-3">
          {isLoading ? (
            <Loader />
          ) : (
            <>
              <span className="text-[#2F2F2F] font-medium text-[0.9rem]">
                Attachments
              </span>
              <div
                className="flex flex-col gap-2 aling-center w-full items-center cursor-pointer border-[2px] !border-dashed border-[#c0c0c0] p-4 md:p-8 rounded-md"
                onClick={handleClick}
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
              >
                <svg
                  width="42"
                  height="30"
                  viewBox="0 0 42 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 30C7.236 30 4.87833 29.0412 2.927 27.1235C0.975667 25.2058 0 22.8622 0 20.0925C0 17.6078 0.799333 15.4225 2.398 13.5365C3.99667 11.6505 5.97933 10.5332 8.346 10.1845C8.987 7.19483 10.4903 4.75 12.856 2.85C15.2213 0.95 17.936 0 21 0C24.6213 0 27.6933 1.26133 30.216 3.784C32.7387 6.30667 34 9.37867 34 13V14H34.6155C36.7232 14.164 38.4808 15.0115 39.8885 16.5425C41.2962 18.0732 42 19.8923 42 22C42 24.2307 41.2308 26.1217 39.6925 27.673C38.1538 29.2243 36.2692 30 34.0385 30H23.1155C22.1052 30 21.25 29.65 20.55 28.95C19.85 28.25 19.5 27.3948 19.5 26.3845V15.4305L15.8 19.069L13.6925 16.981L21 9.673L28.3075 16.981L26.2 19.069L22.5 15.4305V26.3845C22.5 26.5385 22.5642 26.6795 22.6925 26.8075C22.8205 26.9358 22.9615 27 23.1155 27H34C35.4 27 36.5833 26.5167 37.55 25.55C38.5167 24.5833 39 23.4 39 22C39 20.6 38.5167 19.4167 37.55 18.45C36.5833 17.4833 35.4 17 34 17H31V13C31 10.2333 30.025 7.875 28.075 5.925C26.125 3.975 23.7667 3 21 3C18.2333 3 15.875 3.975 13.925 5.925C11.975 7.875 11 10.2333 11 13H9.9615C8.0665 13 6.4325 13.6833 5.0595 15.05C3.6865 16.4167 3 18.0667 3 20C3 21.9333 3.68333 23.5833 5.05 24.95C6.41667 26.3167 8.06667 27 10 27H15V30H10Z"
                    fill="#0068FF"
                  />
                </svg>

                <div className="text-black font-normal text-[1rem]">
                  {window.innerWidth > 768 ? "Drag & drop files or" : ""}{" "}
                  <span className="font-medium underline text-[#0068FF] ">
                    Browse
                  </span>
                </div>
                <div className="text-[#555555] font-normal text-[0.8rem]">
                  Supported file types: JPEG, PNG, Doc, DOCX, PDF, PPTX, XLSX,
                  TXT
                </div>
                <input
                  type="file"
                  multiple
                  ref={fileInputRef}
                  onChange={handleChange}
                  className="hidden"
                  accept=".txt,.xlsx,.doc,.docx,.png,.jpeg,.jpg,.pdf,.pptx,.zip"
                />
              </div>
              <div className="w-full text-right text-[#666666] text-[0.8rem]">
                You can upload maximum 8 Files with maximum limit of 500 MB
              </div>
              {selectedFiles.length > 0 && (
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 md:gap-4">
                  {selectedFiles.map((file, index) => (
                    <SelectedFileCard
                      indexToRemove={index}
                      file={file}
                      removeFile={removeFile}
                    />
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </CustomModal>

      {
        globalState.enabled_modules?.includes('youtube_modul') && (
          <UploadLinkModal
            open={showLinkModal}
            onClose={() => setShowLinkModal(false)}
            folderId={currentFolder?.id}
            type={type}
            id={id}
            onUploadComplete={onUploadComplete}
            path={path}
          />
        )
      }
    </>
  );
};

export default UploadFile;